import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "test-env"
}

import { onMounted } from "vue";
import { useRoute } from "vue-router";
import TopBarVue from "./components/TopBar.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const isDevelopment = window.location.hostname !== 'monthlyrecord.mx.abb.com';


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    isDevelopment
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_unref(route).name !== 'Login')
      ? (_openBlock(), _createBlock(TopBarVue, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, { class: "router-body" }),
    _cache[0] || (_cache[0] = _createElementVNode("footer", null, " © 2024 | ABB EUOPC ", -1))
  ], 64))
}
}

})